import { render, staticRenderFns } from "./erButton.vue?vue&type=template&id=1dc9b4f2&"
import script from "./erButton.vue?vue&type=script&lang=js&"
export * from "./erButton.vue?vue&type=script&lang=js&"
import style0 from "./erButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports